export const AppContainerStyle = `
  display: flex;
  flex-direction: column;
  height: 100%;
`;
